module.exports = __webpack_public_path__ + "fcfd52d8dea35fde1d6e6ad8cdde987e.png";